// extracted by mini-css-extract-plugin
export default {"text":"HintOutHippie_text__BzKYe"};